module.exports = __webpack_public_path__ + "img/icon-excel.29d97c1b.svg";